// status-webapp/src/components/common/OfflineBanner.tsx
import { Notice } from "@conuti-das/prince-ui";
import { useRunnerHealth } from "@/hooks/useRunnerHealth";

export function OfflineBanner() {
  const { online } = useRunnerHealth();
  if (online) return null;
  return (
    <Notice tone="critical">
      Runner-Service offline — Trigger und Queue sind deaktiviert. Read-only-Sicht aktiv.
    </Notice>
  );
}
